// extracted by mini-css-extract-plugin
export default {"fact-card":"FactCard_fact-card__eQMZb","fact-card-wrapper":"FactCard_fact-card-wrapper__dYdIn"};